import { HttpBadStatusCodeError } from '@cian/peperrors/shared';
import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger/shared';
import { fetchGetRegionMeta, TGetRegionMetaResponse } from '../../repositories/geo-temp-layer/v1/get-region-meta';
import { IGetRegionMetaResponse } from '../../repositories/geo-temp-layer/entities/region_meta/GetRegionMetaResponse';
import { IRegion } from '../../types/geoSwitcher';

interface IContext {
  httpApi: IHttpApi;
  logger: ILogger;
}

interface IParams {
  regionId: number;
}

export async function fetchRegion({ httpApi, logger }: IContext, { regionId }: IParams): Promise<IRegion | null> {
  try {
    const { response, statusCode }: TGetRegionMetaResponse = await fetchGetRegionMeta({
      httpApi,
      parameters: {
        locationId: regionId,
      },
    });

    if (statusCode !== 200) {
      throw new HttpBadStatusCodeError('Не удалось загрузить регион', statusCode, 'shared.services.fetchRegion');
    }

    return prepareRegion(response);
  } catch (e) {
    logger.error(e, {
      domain: 'shared.services.fetchRegion]',
      message: `Failed to fetch region`,
    });

    return null;
  }
}

function prepareRegion({ location }: IGetRegionMetaResponse): IRegion {
  if (!location) {
    return {
      id: 1,
      displayName: 'Москва',
      mainTownId: null,
      baseHost: 'https://www.cian.ru',
    };
  }

  return {
    id: location.id || 1,
    displayName: location.displayName || 'Москва',
    mainTownId: location.mainTownId || null,
    baseHost: location.baseHost || null,
  };
}
